import { Paper } from "@mui/material";
import React from "react";

const ReGenerateMandate = () => {
  return <Paper elevation={0} sx={{ bgcolor: "transparent" }}></Paper>;
};

export default ReGenerateMandate;
